import { Client } from '@novominteractive/ase-react-apollo';
import settings from 'lib/settings';

export interface AseAuthData {
  token: string
}

const client = new Client({
  connectionHandlers: {
    onDisconnect: () => console.info('Disconnect'),
    onError: (err) => console.error('err', err),
    onInterrupt: (err) => console.error('interrupt', err),
    onResume: (code, sessionPresent) => console.info(`Resume: ${code} ${sessionPresent}`),
  },
  iotConnect: {
    authorizerName: 'AnywareAuthorizer-ci',
  },
  licenseKey: settings.anyware.licenseKey,
  rootTopic: settings.anyware.rootTopic,
});

export default client;
